import defaults from 'superagent-defaults';
import settings from './components/settings';
import { logoutUser } from './actioncreators/LoginActions';

// Create a defaults context
const request = defaults();

let api = {};
api.login = login;
api.configs = settings;
api.config = null;
api.useConfig = useConfig;
api.loadInstallers = loadInstallers;
api.loadInstallerCompanies = loadInstallerCompanies;
api.loadInstallerCompany = loadInstallerCompany;
api.loadCommercialOffers = loadCommercialOffers;
api.addInstallerCompany = addInstallerCompany;
api.disableInstallerCompany = disableInstallerCompany;
api.addInstaller = addInstaller;
api.updateInstallerCompany = updateInstallerCompany;
api.updateInstaller = updateInstaller;
api.updateProduct = updateProduct;
api.disableInstaller = disableInstaller;
api.updateInstallerPassword = updateInstallerPassword;
api.updateInstallerCompanyPassword = updateInstallerCompanyPassword;
api.resetPassword = resetPassword;
api.savePassword = savePassword;
api.loadFilterShops = loadFilterShops;
api.saveCommercialOffer = saveCommercialOffer;
api.saveFilterShop = saveFilterShop;
api.loadProducts = loadProducts;
api.addProduct = addProduct;
api.disableProduct = disableProduct;
api.loadSoftwareVersions = loadSoftwareVersions;
api.addSoftwareVersion = addSoftwareVersion;
api.updateSoftwareVersion = updateSoftwareVersion;
api.deleteSoftwareVersion = deleteSoftwareVersion;
api.uploadFile = uploadFile;
api.changePassword = changePassword;
api.loadManager = loadManager;
api.changePasswordUser = changePasswordUser;
api.loadDocuments = loadDocuments;
api.changeDocumentPosition = changeDocumentPosition;
api.addDocument = addDocument;
api.removeDocument = removeDocument;

var refreshInProgress = false 

export function getAllConfigs() {
  return settings;
}

function useConfig(config) {
  api.config = config;
}

export function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function refreshAuthentication(callback) {
  refreshInProgress = true;
  request
    .post(api.config.API_HOST + 'api/login')
    .send({ refresh_token: localStorage.refresh_token })
    .set('Accept', 'application/json')
    .withCredentials()
    .end((err, res) => {
      refreshInProgress = false;
      callback(err, res);
    });
}

function doCallback(callback) {
  return (err, res) => {
    if (err && err.status === 403) {
      document.cookie = undefined;
      location.assign('/login');
      console.log('loggedout');
    }

    callback(err, res);
  };
}

function checkRefreshInProgress(resolve) {
  if (refreshInProgress === true) {
    setTimeout(checkRefreshInProgress, 50, resolve);
  } else {
    resolve();
  }
}

export function doRequest(req) {
  //Check if token is still valid
  console.log('TTE = ' + (localStorage.access_token_expire_date - new Date().getTime() / 1000) + ' / refreshInProgress: '+refreshInProgress);
  if (
    localStorage.access_token_expire_date < new Date().getTime() / 1000 &&
    (refreshInProgress === false || refreshInProgress === undefined)
  ) {
    console.log('GO');
    refreshInProgress = true;
    new Promise((resolve,reject) => {
      refreshAuthentication(function(err, res) {
        if (!err) {
          let jwt = res.header['x-auth-token'];
          document.cookie = 'jwt=' + jwt;
          localStorage.access_token_expire_date = new Date().getTime() / 1000 + res.body.expires_in;
          localStorage.refresh_token = res.body.refresh_token;
          resolve();
        }else{
          reject();
        }

      });
    }).then(() => {
      request.set('x-auth-token', getCookie('jwt'));
      req();
    }).catch(()=>{
      console.error("Refresh failed")
    });
  } else {
    if (refreshInProgress === true) {
      console.log('WAIT');
      new Promise(resolve => {
        checkRefreshInProgress(resolve);
      }).then(() => {
        // Setup some defaults
        request.set('x-auth-token', getCookie('jwt'));
        req();
      });
    } else {
      request.set('x-auth-token', getCookie('jwt'));
      req();
    }
  }
}

export function login(username, password, callback) {
  let randomIndex = Math.floor(Math.random() * api.configs.length);
  const first = randomIndex % api.configs.length;

  doLoginCall(first, randomIndex, username, password, callback);
  // doLoginCall(0, 1, username, password, callback);
}

function doLoginCall(firstIndex, index, username, password, callback) {
  request
    .post(api.configs[index].API_HOST + 'api/login')
    .send({ username: username, password: password })
    .set('Accept', 'application/json')
    .withCredentials()
    .end(function(err, res) {
      if (res.status === 200 || index === firstIndex - 1 || (index === api.configs.length - 1 && firstIndex === 0)) {
        callback(err, res);
      } else {
        index++;
        if (index === api.configs.length) {
          index = 0;
        }
        doLoginCall(firstIndex, index, username, password, callback);
      }
    });
}

export function loadInstallers(installerCompany, callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/installer-company/' + installerCompany.id + '/installers')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadInstallerCompanies(callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/installer-company')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadInstallerCompany(id, callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/installer-company/' + id)
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadManager(id, callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/manager/' + id)
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadProducts(callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/products')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadSoftwareVersions(callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/softwareVersions?projection=full')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadCommercialOffers(callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/commercialOffers')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadFilterShops(callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/filterShops')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function addInstallerCompany(installerCompany, callback) {
  let installerCompanyToSave = {};
  installerCompanyToSave.id = installerCompany.id;
  installerCompanyToSave.username = installerCompany.username;
  installerCompanyToSave.email = installerCompany.email;
  installerCompanyToSave.password = installerCompany.password;
  installerCompanyToSave.address = installerCompany.address;
  installerCompanyToSave.country = installerCompany.country;
  installerCompanyToSave.companyName = installerCompany.companyName;
  installerCompanyToSave.beta = installerCompany.beta;

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/installer-company/new')
      .send(installerCompanyToSave)
      .type('application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function addInstaller(installer, callback) {
  let installerToAdd = {};

  installerToAdd.address = installer.address;
  installerToAdd.email = installer.email;
  installerToAdd.password = installer.password;
  installerToAdd.phonenumber = installer.phonenumber;
  installerToAdd.username = installer.username;
  installerToAdd.installerCompanyId = installer.installerCompany;

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/installer/new')
      .send(installerToAdd)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function addProduct(product, callback) {
  let productToAdd = {};

  productToAdd.productID = product.productID;
  productToAdd.name = product.name;
  productToAdd.articlePrefix = product.articlePrefix;

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/products/new')
      .send(productToAdd)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function addSoftwareVersion(swVersion, callback) {
  let softwareVersionToAdd = {};

  softwareVersionToAdd.version = swVersion.version;
  softwareVersionToAdd.name = swVersion.name;
  softwareVersionToAdd.size = swVersion.size;
  softwareVersionToAdd.url = swVersion.url;
  softwareVersionToAdd.md5 = swVersion.md5;
  softwareVersionToAdd.productId = swVersion.product;
  softwareVersionToAdd.beta = swVersion.beta;
  softwareVersionToAdd.country = swVersion.country;

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/softwareVersions/new')
      .send(softwareVersionToAdd)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateInstallerCompany(installerCompany, callback) {
  let installerCompanyToUpdate = {};

  installerCompanyToUpdate.address = installerCompany.address;
  installerCompanyToUpdate.country = installerCompany.country;
  installerCompanyToUpdate.email = installerCompany.email;
  installerCompanyToUpdate.password = installerCompany.password;
  installerCompanyToUpdate.phonenumber = installerCompany.phonenumber;
  installerCompanyToUpdate.username = installerCompany.username;
  installerCompanyToUpdate.beta = installerCompany.beta;
  installerCompanyToUpdate.companyName = installerCompany.companyName;

  doRequest(() =>
    request
      .put(api.config.API_HOST + 'api/installer-company/' + installerCompany.id + '/update')
      .send(installerCompanyToUpdate)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateProduct(product, callback) {
  let productToUpdate = {};

  productToUpdate.name = product.name;
  productToUpdate.productID = product.productID;
  productToUpdate.articlePrefix = product.articlePrefix;

  doRequest(() =>
    request
      .put(product._links.self.href + '/update')
      .send(productToUpdate)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateSoftwareVersion(swVersion, callback) {
  let softwareVersionToUpdate = {};

  softwareVersionToUpdate.version = swVersion.version;
  softwareVersionToUpdate.name = swVersion.name;
  softwareVersionToUpdate.beta = swVersion.beta;
  softwareVersionToUpdate.country = swVersion.country;
  if (swVersion.product instanceof Object) {
    softwareVersionToUpdate.productId = swVersion.product.productID;
  } else {
    softwareVersionToUpdate.productId = swVersion.product;
  }

  doRequest(() =>
    request
      .patch(swVersion._links.self.href)
      .send(softwareVersionToUpdate)
      .type('application/json')
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateInstaller(installer, callback) {
  let installerToUpdate = {};

  installerToUpdate.address = installer.address;
  installerToUpdate.email = installer.email;
  installerToUpdate.password = installer.password;
  installerToUpdate.phonenumber = installer.phonenumber;
  installerToUpdate.username = installer.username;
  installerToUpdate.installerCompanyId = installer.installerCompany;

  doRequest(() =>
    request
      .put(api.config.API_HOST + 'api/installer/' + installer.id + '/update')
      .send(installerToUpdate)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function disableInstaller(installer, callback) {
  let installerToDisable = {};

  installerToDisable.username = installer.username;

  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/installer/disable')
      .send(installerToDisable)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function disableInstallerCompany(installerCompany, callback) {
  let installerCompanyToDisable = {};

  installerCompanyToDisable.username = installerCompany.username;

  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/installer-company/disable')
      .send(installerCompanyToDisable)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function disableProduct(product, callback) {
  let productToDisable = {};

  productToDisable.productID = product.productID;

  doRequest(() =>
    request
      .delete(api.config.API_HOST + 'api/products/' + productToDisable.productID)
      .send(productToDisable)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function deleteSoftwareVersion(swVersion, callback) {
  let softwareVersionToDelete = {};

  softwareVersionToDelete.version = swVersion.version;
  softwareVersionToDelete.id = swVersion.id;

  doRequest(() =>
    request
      .delete(api.config.API_HOST + 'api/softwareVersions/' + softwareVersionToDelete.id)
      .send(softwareVersionToDelete)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateInstallerPassword(username, password, callback) {
  let newuser = {};
  newuser.username = username;
  newuser.newPassword = password;
  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/installer/changepassword')
      .send(newuser)
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function updateInstallerCompanyPassword(username, password, callback) {
  let newuser = {};
  newuser.username = username;
  newuser.newPassword = password;
  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/installer-company/changepassword')
      .send(newuser)
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function resetPassword(email, callback) {
  let randomIndex = Math.floor(Math.random() * api.configs.length);
  let randomHost = api.configs[randomIndex].API_HOST;

  doRequest(() =>
    request
      .post(randomHost + 'api/users/resetPassword/' + encodeURIComponent(email).replace('.', '%2E'))
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function savePassword(id, token, newPassword, callback) {
  let user = {};
  user.newPassword = newPassword;

  doRequest(() =>
    request
      .patch(api.configs[0].API_HOST + 'api/users/savePassword/' + id + '/' + token)
      .send(user)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function changePassword(currentPassword, newPassword, callback) {
  let user = {};
  user.newPassword = newPassword;
  user.password = currentPassword;

  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/users/changePassword')
      .send(user)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function changePasswordUser(user, newPassword, callback) {
  let userToSave = {};

  userToSave.accountEnabled = user.accountEnabled;
  userToSave.address = user.address;
  userToSave.companyName = user.companyName;
  userToSave.country = user.country;
  userToSave.email = user.email;
  userToSave.id = user.id;
  userToSave.newPassword = newPassword;
  userToSave.phonenumber = user.phonenumber;
  userToSave.username = user.username;

  doRequest(() =>
    request
      .patch(api.config.API_HOST + 'api/users/changePasswordUser')
      .send(userToSave)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function saveCommercialOffer(offer, callback) {
  if (offer._links) {
    doRequest(() =>
      request
        .put(offer._links.self.href)
        .send(offer)
        .type('application/json')
        .set('Accept', 'application/json')
        .withCredentials()
        .end(doCallback(callback))
    );
  } else {
    doRequest(() =>
      request
        .post(api.config.API_HOST + 'api/commercialOffers')
        .send(offer)
        .type('application/json')
        .withCredentials()
        .end(doCallback(callback))
    );
  }
}

export function saveFilterShop(filterShop, callback) {
  if (filterShop._links) {
    doRequest(() =>
      request
        .put(filterShop._links.self.href)
        .send(filterShop)
        .type('application/json')
        .set('Accept', 'application/json')
        .withCredentials()
        .end(doCallback(callback))
    );
  } else {
    doRequest(() =>
      request
        .post(api.config.API_HOST + 'api/filterShops')
        .send(filterShop)
        .type('application/json')
        .withCredentials()
        .end(doCallback(callback))
    );
  }
}

export function uploadFile(type, data, name, productId, version, country, callback) {
  let formData = new FormData();

  formData.append('country', country);
  formData.append('data', data);
  formData.append('name', name);
  if (productId != null){
    formData.append('productId', productId);
  }
  formData.append('version', version);

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/upload/' + type)
      .send(formData)
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function loadDocuments(country, callback) {
  let countryParam = country !== undefined ? '?' + country : '';

  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/documents' + countryParam)
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function changeDocumentPosition(oldIndex, newIndex, callback) {
  doRequest(() =>
    request
      .get(api.config.API_HOST + 'api/documents/changePosition' + '/' + oldIndex + '/' + newIndex)
      .set('Accept', 'application/json')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function addDocument(document, callback) {
  let documentToAdd = {};

  documentToAdd.id = document.id;
  documentToAdd.type = 'URL'; //document.type;
  documentToAdd.url = document.url;
  documentToAdd.name = document.name;
  documentToAdd.description = document.description;
  documentToAdd.situation = 'GENERAL'; //document.situation;
  documentToAdd.model = document.model;
  documentToAdd.country = document.country;

  doRequest(() =>
    request
      .post(api.config.API_HOST + 'api/documents/new')
      .send(documentToAdd)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export function removeDocument(document, callback) {
  doRequest(() =>
    request
      .delete(api.config.API_HOST + 'api/documents/' + document.value.id)
      .type('application/json')
      .set('Accept', 'text/plain')
      .withCredentials()
      .end(doCallback(callback))
  );
}

export default api;



// WEBPACK FOOTER //
// /src/api.js